var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2381_11112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 6.00977L10 10.0848L17.4453 6.00977",
    stroke: "#494949",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 1.95171L17.175 5.71577C17.2732 5.76948 17.3551 5.84857 17.4123 5.94476C17.4695 6.04096 17.4997 6.15074 17.5 6.26264V13.7345C17.4997 13.8464 17.4695 13.9562 17.4123 14.0524C17.3551 14.1486 17.2732 14.2277 17.175 14.2814L10.3 18.0455C10.208 18.0958 10.1049 18.1222 10 18.1222C9.89515 18.1222 9.79198 18.0958 9.7 18.0455L2.825 14.2814C2.72683 14.2277 2.64488 14.1486 2.58772 14.0524C2.53055 13.9562 2.50025 13.8464 2.5 13.7345V6.26264C2.50025 6.15074 2.53055 6.04096 2.58772 5.94476C2.64488 5.84857 2.72683 5.76948 2.825 5.71577L9.7 1.95171C9.79198 1.90138 9.89515 1.875 10 1.875C10.1049 1.875 10.208 1.90138 10.3 1.95171Z",
    stroke: "#494949",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.0859V18.1258",
    stroke: "#494949",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2381_11112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCube);
export default __webpack_public_path__ + "static/media/RCube.c90368839a4f8674fcd4cf9395198d3c.svg";
export { ForwardRef as ReactComponent };